module.exports = __webpack_public_path__ + "img/thumbnail_Hippopotamus_j_albino.e2912c68.png";